var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hour-trading-metric"},_vm._l((_vm.metrics),function(m){return _c('span',{key:m.key},[_c('span',[_vm._v(_vm._s(m.name)+":")]),_vm._v(" "),_c('span',{staticClass:"number"},[_vm._v(_vm._s(m.value))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }